export enum ComponentLayout {
  Normal = 'normal',
  Small = 'small',
}
